import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['addressVisible', 'addressOptions', 'phoneNumberVisible', 'phoneNumberOptions']

  handleSwitchFields(e) {
    this.addressVisibleTarget.classList.toggle('hidden', this.addressOptionsTarget.checked)
    this.phoneNumberVisibleTarget.classList.toggle('hidden', this.phoneNumberOptionsTarget.checked)
  }
}
